import {Avatar, message, Modal} from 'antd'
import {getId} from 'apis/model/base'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {withProps} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, pagerControls, renderIf} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import getAvatar from '../../../../helpers/getAvatar'
import {FetchTeacherById} from '../components/FetchEntity'
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {timetable_getTeacherSubjectsOfCourseClass_Api} from "../../../../apis";
import {FaUserTie} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {renderIfElse, renderMail, renderPhone} from "../../../Shared";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {BsInboxesFill} from "react-icons/bs";
import copyToClipboard from "copy-to-clipboard";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {IoCopyOutline} from "react-icons/io5";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import getAliasName from "../../../../helpers/getAliasName";
import ImageLoader from "../../../../components/ImageLoader";
import {NoImage} from "../../../../conts/imageBase64";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {FiChevronsRight} from "react-icons/fi";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import classNames from "classnames"


// Bảng màu avatar khi giáo viên CHƯA có ảnh - hash ổn định theo tên/mã (luôn ra cùng 1 màu cho cùng
// 1 người qua các lần render, không đổi màu ngẫu nhiên) - cùng quy ước AVATAR_COLORS đã dùng ở
// CourseClassAttendanceForm.js/CourseClassGradeTab.js (điểm danh/bảng điểm), tái dùng cho đồng bộ
// thay vì tự chế bảng màu khác. Theo mẫu thiết kế được yêu cầu (icon người trong vòng tròn màu),
// khác hẳn nền xám "background-200" mặc định cũ.
const TEACHER_AVATAR_COLORS = ['bg-indigo-500', 'bg-red-500', 'bg-amber-500', 'bg-purple-500', 'bg-teal-500', 'bg-blue-500', 'bg-pink-500']
const getTeacherAvatarColorClass = (str = '') => {
    let hash = 0
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash)
    return TEACHER_AVATAR_COLORS[Math.abs(hash) % TEACHER_AVATAR_COLORS.length]
}

// Layout đồng bộ với card "Phụ trách" (CourseTeacherTab.js/renderItem) - card tự đủ viền/bo góc/
// shadow, môn học đảm nhiệm dời thành badge NGAY CẠNH tên (thay dòng phụ mờ bên dưới trước đây -
// cùng vai trò với badge "chức vụ" bên card Phụ trách), mã giảng viên hạ xuống dòng riêng màu
// nhạt, action ("Xem chi tiết") dời hẳn sang PHẢI card (xem renderActions ở CourseClassTeachers
// bên dưới) thay vì nằm cuối card như trước.
export const renderCourseClassTeacherItem =
    ({translate: t, isLg, detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
        const {teacher, subject, subjects_in_the_same = []} = item ?? {}
        const {avatar, prefix_title, teacher_idcode, fullname, contact_phone, contact_email, user, hashtags} = teacher ?? {}
        const tags = (hashtags || "").split(",").filter(e => !!e);
        // fullname trống nhưng hồ sơ ĐÃ gắn user (tài khoản liên kết) - lấy tên user thay vì để
        // trống trắng cả dòng (bug thật gặp: giảng viên chỉ mới link tài khoản, chưa nhập fullname
        // riêng cho hồ sơ giảng viên).
        const displayName = fullname || getTitle(user)
        const hasAvatarImage = !!(avatar || getAvatar(user))

        return (
            <div key={index} className="p-4 flex items-start gap-3 background border border-color-50 rounded-xl shadow-sm hover:shadow-md transition-all">
                <Avatar
                    size={44}
                    src={avatar || getAvatar(user)}
                    icon={<FaUserTie size={18} className="text-white"/>}
                    className={classNames(
                        "mt-0.5 flex flex-center flex-shrink-0",
                        !hasAvatarImage && getTeacherAvatarColorClass(displayName || teacher_idcode || String(index))
                    )}
                />
                <div className="flex flex-col flex-1 min-w-0 gap-1">
                    <div className="flex items-center flex-wrap gap-2">
                        {renderIfElse(
                            user,
                            <Link to={getLinkToDetail(user)}
                                  className="font-bold text-base text-color-000 no-underline leading-snug truncate">
                                {(user?.patron_saint_name || prefix_title) && (
                                    <span className="mr-1 font-medium text-sm text-color-300">
                                        {user?.patron_saint_name || prefix_title}
                                    </span>
                                )}
                                {displayName}
                            </Link>,
                            <span className="font-bold text-base text-color-000 leading-snug truncate">
                                {prefix_title && (
                                    <span className="mr-1 font-medium text-sm text-color-300">{prefix_title}</span>
                                )}
                                {displayName}
                            </span>
                        )}
                        {renderIf(
                            subject?.title,
                            <span className="px-2 py-0.5 border border-secondary-400 background rounded-full font-bold text-2xs text-secondary-500 whitespace-no-wrap">
                                {getTitle(subject)}
                            </span>
                        )}
                    </div>
                    {renderIf(
                        teacher_idcode,
                        <span
                            onClick={() => {
                                copyToClipboard(teacher_idcode)
                                message.info(t('copied'))
                            }}
                            className="w-fit font-mono text-xs text-color-300 hover:text-blue-500 cursor-pointer">
                            {isLg ? `${t('teacher code')} : ` : '#'}{teacher_idcode}
                            <IoCopyOutline size={10} className="ml-1"/>
                        </span>
                    )}

                    {/* Thông tin phụ (dạy phụ/liên hệ/tag) - giữ NGUYÊN dữ liệu cũ, chỉ đổi cỡ chữ
                        đồng bộ card Phụ trách (text-xs thay text-2xs). */}
                    <div className="mt-1 flex flex-col gap-1">
                        {renderIf(
                            subjects_in_the_same?.length > 0,
                            <ItemInformation
                                showIcon={true}
                                label="teaching assistant for"
                                value={subjects_in_the_same.map((e) => getTitle(e)).join(', ')}
                                className="text-xs tracking-wider"
                            />
                        )}
                        {renderIf(
                            _.some([contact_phone, contact_email]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="contact"
                                valueFirst={renderPhone(contact_phone)}
                                labelSecond={contact_email && " - " || ''}
                                valueSecond={renderMail(contact_email)}
                                className="text-xs tracking-wider"
                            />
                        )}
                        {renderIf(
                            tags.length > 0,
                            <div className="flex flex-wrap gap-2">
                                {tags.map((ee, ii) => (
                                    <span
                                        key={ii}
                                        style={{
                                            width: 'fit',
                                            height: 16,
                                            padding: '0 8px',
                                            fontSize: 9,
                                            borderRadius: 999
                                        }}
                                        className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                        {ee}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex items-center flex-shrink-0">
                    {renderActions(item)}
                </div>
            </div>
        )
    }

const renderTeacherItem = ({renderActions = NullAsDefault} = {}) => (item, index) => {
    const {teacher, subject, subjects_in_the_same = []} = item ?? {}
    const {avatar, prefix_title, fullname, contact_phone, contact_email, teacher_idcode, user, hashtags} = teacher ?? {}
    const tags = (hashtags || "").split(",").filter(e => !!e);
    // fullname trống nhưng hồ sơ ĐÃ gắn user - lấy tên user (xem comment renderCourseClassTeacherItem).
    const displayName = fullname || getTitle(user)
    const {isSm} = useContext(LayoutContext)

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    className="p-3 flex flex-col border border-color-50 hover:shadow-md rounded-lg hover:scale-2xs custom-item-render relative">
                    <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                        <Avatar
                            size={35}
                            src={avatar || getAvatar(user)}
                            icon={<FaUserTie size={15} className="text-color-500"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col flex-1">
                            {renderIfElse(
                                user,
                                <Link to={getLinkToDetail(user)}
                                      className="font-bold text-color-000 no-underline leading-snug">
                                    {prefix_title && (
                                        <span
                                            className="mr-1 font-medium text-sm text-color-100 italic">{prefix_title}</span>
                                    )}
                                    {displayName}
                                </Link>,
                                <span
                                    className="font-medium text-sm text-color-100 leading-snug">
                                        <span className="italic">{prefix_title}</span>
                                        <span className="ml-1 font-bold text-color-000">{displayName}</span>
                                    </span>
                            )}
                            <div className="flex items-center gap-6">
                                {renderIf(
                                    teacher_idcode,
                                    <div className="text-xs text-color-500 italic">
                                        <span className="whitespace-no-wrap">
                                            {isSm ? '#' : `${t('teacher code')} : `}
                                        </span>
                                        <span
                                            onClick={() => {
                                                copyToClipboard(teacher_idcode)
                                                message.info(t('copied'))
                                            }}
                                            className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                            {teacher_idcode}
                                            <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                    </div>
                                )}
                                {renderIf(
                                    tags.length > 0,
                                    <div className="flex gap-2">
                                        {tags.map((ee, ii) => (
                                            <span key={ii}
                                                  style={{
                                                      width: 'fit',
                                                      height: 16,
                                                      padding: '0 8px',
                                                      fontSize: 9,
                                                      borderRadius: 999
                                                  }}
                                                  className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                                {ee}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="ml-3 flex flex-col">
                        <ItemInformation showIcon={true} label="subject taught" value={subject?.title}
                                         className="text-xs italic"/>
                        {renderIf(
                            subjects_in_the_same?.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-500">
                                {`${t('teaching assistant for')} : `}
                            </span>
                                {subjects_in_the_same.map((e, i) => (
                                    <span key={i} className="font-bold text-color-100">
                                  {getTitle(e)} {i < subjects_in_the_same?.length - 1 && ', '}
                                </span>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            _.some([contact_phone, contact_email]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="contact"
                                valueFirst={renderPhone(contact_phone)}
                                labelSecond={contact_email && " - " || ''}
                                valueSecond={renderMail(contact_email)}
                                className="text-xs italic"
                            />
                        )}
                    </div>
                    <div className="text-right">
                        {renderActions(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}

const DetailModalContent = ({item, course_class, onCancel = NullAsDefault}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {edit} = course_class ?? {}
    const {
        avatar,
        user,
        prefix_title,
        teacher_idcode,
        fullname,
        gender,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
        contact_address,
        majors,
        degrees,
        experiences,
        fields,
        hashtags,
    } = item ?? {}

    const tags = (hashtags || "").split(",").filter(e => !!e);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <div className="flex flex-col">
                    <span className="font-semibold text-sm text-gray-700 tracking-wide">
                        {t('teacher information')}
                    </span>
                    <div style={{height: 3}} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
                <div className="ml-2 flex gap-3">
                    <ImageLoader
                        style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                        src={avatar || getAvatar(user) || NoImage}
                        fallback={NoImage}
                        className="background-200 rounded-xl object-cover mt-1"
                    />
                    <div className="flex flex-col flex-1 gap-1">
                        <ItemInformation
                            primary={true} showIcon={true} label={!isSm && "full name"}
                            value={`${prefix_title || ''} ${fullname}`}
                            className="text-sm italic tracking-wider"
                        />
                        <ItemInformation
                            showIcon={true} label="teacher code"
                            value={`#${teacher_idcode}`}
                            className="italic tracking-wider"
                        />
                        {renderIf(
                            gender !== 0,
                            <ItemInformation
                                showIcon={true} label={!isSm && "gender"}
                                value={t(getLabelOfGender(gender))} className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            tags.length,
                            <div className="flex items-center gap-2 mt-2">
                                {tags.map((ee, ii) => (
                                    <span
                                        key={ii}
                                        style={{padding: '2px 8px'}}
                                        className="rounded-full border border-primary-300 font-medium text-2xs text-primary-300 italic leading-tight">
                                        {ee}
                                    </span>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            user,
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={30}
                                    src={getAvatar(user)}
                                    icon={<FaUserTie size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                                    <span className="text-blue-500 italic tracking-wider">
                                        {`${t('link account')} : `}
                                    </span>
                                    {renderIfElse(
                                        edit === true,
                                        <Link
                                            target="_blank" to={getLinkToDetail(user)}
                                            className="font-medium text-primary-700 no-underline leading-snug">
                                            {getAliasName(user, 'patron_saint')}
                                            {` ${getTitle(user)}`}
                                        </Link>,
                                        <span className="font-medium text-primary-700 leading-snug">
                                            {getAliasName(user, 'patron_saint')}
                                            {getTitle(user)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {renderIf(
                edit,
                <div className="flex flex-col gap-1">
                    <div className="flex flex-col">
                        <span className="font-semibold text-sm text-gray-700 tracking-wide">
                            {t('contact information')}
                        </span>
                        <div style={{height: 3}} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <div className="ml-2 flex flex-col gap-1">
                        <ItemInformation showIcon={true} label="phone" value={contact_phone}
                                         className="italic tracking-wider"/>
                        <ItemInformation showIcon={true} label="email" value={contact_email}
                                         className="italic tracking-wider"/>
                        <ItemInformation showIcon={true} label="address" value={contact_address}
                                         className="italic tracking-wider"/>
                    </div>
                </div>
            )}
            {renderIf(
                _.some([majors, degrees, experiences, fields]),
                <div className="flex flex-col gap-1">
                    <div className="flex flex-col">
                        <span className="font-semibold text-sm text-gray-700 tracking-wide">
                            {t('education level')}
                        </span>
                        <div style={{height: 3}} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <div className="ml-2 flex flex-col gap-1">
                        <ItemInformation showIcon={true} label="majors" value={majors}
                                         className="italic tracking-wider"/>
                        <ItemInformation showIcon={true} label="degrees" value={degrees}
                                         className="italic tracking-wider"/>
                        <ItemInformation showIcon={true} label="experiences" value={experiences}
                                         className="italic tracking-wider"/>
                        <ItemInformation showIcon={true} label="fields" value={fields}
                                         className="italic tracking-wider"/>
                    </div>
                </div>
            )}
            <div className="flex justify-end p-3 mt-3">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

const CourseClassTeachers = ({
                                 item,
                                 renderList,
                                 detail = false,
                                 controls = pagerControls,
                                 ...props
                             }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {edit} = item ?? {}

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course_class_id = getId(item)
    const {keyword, component: search_widget} = controls?.search ?? {}

    const apiInfo = timetable_getTeacherSubjectsOfCourseClass_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path.replace(':id', course_class_id),
            JSON.stringify(keyword),
        ].join('/'),
        [course_class_id, keyword]
    )

    const onCancel = () => {
        setAction({})
    }

    const modal = useMemo(() => {
        const {teacher} = action?.value ?? {}
        const id = getId(teacher)
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {}
        let modal_params = {}
        switch (action?.type) {
            case CRUD.READ:
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('teacher')}
                        </div>
                    ),
                }
                params = {
                    course_class: item,
                    onCancel: () => {
                        onCancel()
                    }
                }
                Content = DetailModalContent
                Wrapper = withProps({id})(FetchTeacherById)
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [item, action])

    // Nút "Xem chi tiết" đổi từ link chữ cuối card sang nút bo viền LUÔN HIỆN RÕ ở bên phải card -
    // đồng bộ nút Sửa/Xóa của card "Phụ trách" (CourseTeacherTab.js), không còn hover-reveal.
    const renderActions = useCallback(
        (item) =>
            renderIf(
                edit,
                <button
                    type="button"
                    onClick={() => {
                        setAction({type: CRUD.READ, value: item})
                    }}
                    className="px-3 py-1.5 flex items-center gap-1.5 border border-color-200 hover:border-indigo-400 hover:bg-indigo-50 rounded-lg text-xs font-semibold text-color-300 hover:text-indigo-600 transition-colors whitespace-no-wrap">
                    {t('view detail')}
                    <FiChevronsRight size={13}/>
                </button>
            ),
        [edit]
    )

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col flex-1">
                <h3 className="font-bold text-base text-slate-600 tracking-wide">
                    {t('teachers of classes')}
                </h3>
                <div style={{height: 3}} className="my-1 w-20 rounded-full bg-gray-400"/>
            </div>
            {search_widget}
            {_.isFunction(renderList) ? (
                renderList({
                    edit,
                    action,
                    detail,
                    renderItem: renderTeacherItem({
                        renderActions,
                    }),
                })
            ) : (
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    refreshKey={refreshKey}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: course_class_id})}
                    renderItem={renderCourseClassTeacherItem({
                        translate: t,
                        isLg: isLg,
                        detail,
                        renderActions,
                    })}
                    // Card riêng biệt (gap-3) thay vì list dính liền chia bằng gạch ngang (divide-y) -
                    // đồng bộ cách trình bày với card "Phụ trách" (CourseTeachers.js).
                    renderWrap={(child) => (
                        <div className="flex flex-col gap-3">
                            {child}
                        </div>
                    )}
                    renderEmpty={() => (
                        <div className="px-6 py-10 flex flex-col items-center gap-4">
                            <BsInboxesFill size={60} style={{color: '#dedede'}}/>
                            <div className="flex flex-col gap-1">
                                <span className="text-center font-medium text-color-100 tracking-wide">
                                    {t('instructor_added_via_subjects_title')}
                                </span>
                                <span
                                    className="text-center text-xs text-color-300 tracking-wider italic whitespace-pre-line">
                                    {t('instructor_added_via_subjects_description')}
                                </span>
                            </div>
                        </div>
                    )}
                    {...props}
                />
            )}
            {modal}
        </div>
    )
}

export default CourseClassTeachers
